export default "__VITE_ASSET__Bw1G7Zs6__"